import { Box, Button, Popover, TextField } from "@mui/material";
import React, { useRef, useState } from "react";
import { useStyles } from "./styles";

const CustomJsonEditer = ({ title, element, onChange, handleError }) => {
  const anchorRef = useRef(null);
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [state, setState] = useState(
    element.default ? JSON.stringify(element.default) : ""
  );

  const handleChange = (event) => {
    const { value } = event.target;
    setState(value);
  };

  const handleClose = () => {
    try {
      onChange(state ? JSON.parse(state) : "");
      setAnchorEl(null);
    } catch {
      handleError(element);
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "popover-textfields" : undefined;

  return (
    <Box className={classes.root}>
      <Button
        title={title}
        ref={anchorRef}
        className={classes.openBtn}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {element?.name}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        PaperProps={{
          style: {
            width: anchorRef.current ? anchorRef.current.clientWidth : null,
          },
        }}
      >
        <Box px={3} py={2}>
          <TextField
            multiline
            margin="normal"
            minRows={5}
            maxRows={20}
            id={element.name}
            label={element.name}
            name={element.name}
            value={state}
            variant="outlined"
            onChange={handleChange}
            style={{
              minHeight: "200px",
              minWidth: "100%",
            }}
          />
        </Box>
      </Popover>
    </Box>
  );
};

export default CustomJsonEditer;
